<div class="card">
    <div class="card-body p-3">
        <h5 class="mb-2 font-weight-bold" [ngClass]="{'p-2':isMylearning}">{{ "TROUBLESHOOTING" | translate }}</h5>
        <hr />

        <div id="helpAccordion">
            <ng-container *ngFor="let panel of [1,2,3,4]; let i = index">
                <div class="card mb-1 border-0 border-top">
                    <div class="card-header bg-white pb-3 accordion-header"
                        [ngClass]="{'pt-0':isMylearning, 'pt-2':isMylearning && i!==0}" (click)="togglePanel(panel)"
                        style="cursor: pointer;">
                        <h6 class="mb-0 d-flex justify-content-between align-items-center text-dark pr-0">
                            <span class="font-weight-bold">
                                {{
                                panel === 1 ? ("HELP_COPY_PASTE" | translate) :
                                panel === 2 ? ("HELP_CREDENTIALS" | translate) :
                                panel === 3 ? ("HELP_POPUP_ISSUES" | translate) :
                                ("HELP_KEYBOARD_NAVIGATION" | translate)
                                }}
                            </span>
                            <span class="text-primary font-weight-bold" style="font-size: x-large;">
                                {{ panelStates[panel] ? '−' : '+' }}
                            </span>
                        </h6>
                    </div>
                    <div *ngIf="panelStates[panel]" [@accordionAnimation]>
                        <div class="card-body pt-2 pb-3">
                            <ng-container [ngSwitch]="panel">
                                <ng-container *ngSwitchCase="1">
                                    <p>{{ "HELP_COPY_PASTE_DESC" | translate }}</p>

                                    <div class="table-responsive mt-2" style="overflow-x: auto;">
                                        <table class="table table-bordered table-sm text-center mb-0"
                                            style="min-width: 500px;">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 25% !important;">{{ "OS_ATTENDEE" | translate }}</th>
                                                    <th>{{ "OS_VM" | translate }}</th>
                                                    <th>{{ "COPY" | translate }}</th>
                                                    <th>{{ "PASTE" | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="osInfo === 'Windows'">
                                                    <tr>
                                                        <td>Windows</td>
                                                        <td>Windows</td>
                                                        <td>Ctrl + C</td>
                                                        <td>Ctrl + V</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Windows</td>
                                                        <td>Linux</td>
                                                        <td>Ctrl + C</td>
                                                        <td>Ctrl + Shift + V</td>
                                                    </tr>
                                                </ng-container>

                                                <ng-container *ngIf="osInfo === 'Mac OS'">
                                                    <tr>
                                                        <td>Mac</td>
                                                        <td>Windows</td>
                                                        <td>Command + C</td>
                                                        <td>Command + V</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Mac</td>
                                                        <td>Linux</td>
                                                        <td>Command + C</td>
                                                        <td>Control + Shift + V</td>
                                                    </tr>
                                                </ng-container>
                                        </table>
                                    </div>

                                    <ul class="mt-3">
                                        <li class="mb-2">✅ {{ "COPY_RIGHT_CLICK" | translate }}</li>
                                        <li class="mb-2" *ngIf="pasteInVM"><i class="fa-regular fa-paste"></i> {{
                                            "CLIPBOARD_BUTTON" | translate
                                            }}</li>
                                        <li class="mb-2"><i class="fa-regular fa-copy"></i> {{ "COPY_ONLY_BUTTON" | translate }}
                                        </li>
                                    </ul>
                                </ng-container>

                                <ng-container *ngSwitchCase="2">
                                    <p *ngIf="!isGridView" [innerHTML]="'HELP_CREDENTIALS_DESC_HTML' | translate"></p>
                                    <p *ngIf="isGridView" [innerHTML]="'HELP_CREDENTIALS_DESC_HTML_GRID' | translate"></p>
                                </ng-container>

                                <ng-container *ngSwitchCase="3">
                                    <p>{{ "HELP_POPUP_ISSUES_DESC" | translate }}</p>
                                </ng-container>

                                <ng-container *ngSwitchCase="4">
                                    <p>{{ "HELP_KEYBOARD_NAVIGATION_DESC" | translate }}</p>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="support my-4">
            <h6 class="font-weight-bold mb-2">📣 {{ "NEED_MORE_HELP" | translate }}</h6>
            <p class="mb-2">{{ "CONTACT_SUPPORT_TEAM" | translate }}</p>
            <p class="mb-2">
                <strong>{{ "EMAIL" | translate }}:</strong>
                <a [href]="generateSupportMailLink()" target="_blank" rel="noopener noreferrer">
                    {{ supportEmail }}
                </a>
            </p>
            <p class="mb-2">
                <strong>{{ "DEPLOYMENT_ID" | translate }}:</strong> {{ deploymentID }}
            </p>
            <p class="text-muted mb-0">({{ "INCLUDE_ID_NOTE" | translate }})</p>
        </div>
    </div>
</div>